import Dropdown from 'flarum/common/components/Dropdown';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';
import TicketStatusFilterButton from './TicketStatusFilterButton';

export default class TicketStatusFilter extends Dropdown {
  static initAttrs(attrs) {
    attrs.buttonClassName = attrs.buttonClassName || 'Button';

    attrs.accessibleToggleLabel = 'Ticket status';

    super.initAttrs(attrs);
  }

  view(vnode) {
    return super.view({ ...vnode, children: this.items().toArray() });
  }

  getButtonContent() {
    let count = this.attrs.filters.length;

    if (this.attrs.showSolved) {
      count++;
    }

    return (
      <>
        {app.translator.trans('v17development-flarum-support.forum.tickets.overview.filter.status.title')}{' '}
        <span className={'SupportTicketFilterStatusButton'}>
          {count >= 1
            ? app.translator.trans('v17development-flarum-support.forum.tickets.overview.filter.status.filter_count', {
                count,
              })
            : app.translator.trans('v17development-flarum-support.forum.tickets.overview.all_tickets')}
        </span>
      </>
    );
  }

  getMenu(items) {
    return (
      <ul
        className={'Dropdown-menu dropdown-menu ' + this.attrs.menuClassName}
        onclick={(e) => {
          e.stopPropagation();
        }}
      >
        {items}
      </ul>
    );
  }

  items() {
    const items = new ItemList();
    const filters = this.attrs.filters;

    // Open tickets only
    items.add(
      'selection_open',
      <TicketStatusFilterButton
        filterLabel={app.translator.trans('v17development-flarum-support.forum.tickets.overview.selection_open')}
        filterIcon={'fas fa-clipboard-list'}
        onFilterClick={() => this.attrs.setFilter('open')}
      />
    );

    // Closed tickets only
    items.add(
      'selection_closed',
      <TicketStatusFilterButton
        filterLabel={app.translator.trans('v17development-flarum-support.forum.tickets.overview.selection_closed')}
        filterIcon={'fas fa-clipboard-check'}
        onFilterClick={() => this.attrs.setFilter('closed')}
      />
    );

    // All tickets
    items.add(
      'selection_unfiltered',
      <TicketStatusFilterButton
        filterLabel={app.translator.trans('v17development-flarum-support.forum.tickets.overview.selection_unfiltered')}
        filterIcon={'fas fa-list-ul'}
        onFilterClick={() => this.attrs.setFilter(null)}
      />
    );
    items.add('seperator', <li className={'Dropdown-separator'} />);

    // New tickets
    items.add(
      'new',
      <TicketStatusFilterButton
        filterStatus={'new'}
        filterIcon={'fas fa-life-ring'}
        isChecked={filters.indexOf(0) >= 0}
        onFilterClick={() => this.attrs.setFilter(0)}
      />
    );

    // Open tickets
    items.add(
      'open',
      <TicketStatusFilterButton
        filterStatus={'open'}
        filterIcon={'fas fa-ticket-alt'}
        isChecked={filters.indexOf(1) >= 0}
        onFilterClick={() => this.attrs.setFilter(1)}
      />
    );

    // Pending tickets
    items.add(
      'pending',
      <TicketStatusFilterButton
        filterStatus={'pending'}
        filterIcon={'fas fa-user-clock'}
        isChecked={filters.indexOf(2) >= 0}
        onFilterClick={() => this.attrs.setFilter(2)}
      />
    );

    // Solved tickets
    items.add(
      'solved',
      <TicketStatusFilterButton
        filterStatus={'solved'}
        filterIcon={'fas fa-check'}
        isChecked={this.attrs.showSolved === true}
        onFilterClick={() => this.attrs.setFilter('solved')}
      />
    );

    // Closed tickets
    items.add(
      'closed',
      <TicketStatusFilterButton
        filterStatus={'closed'}
        filterIcon={'fas fa-flag-checkered'}
        isChecked={filters.indexOf(3) >= 0}
        onFilterClick={() => this.attrs.setFilter(3)}
      />
    );

    // On hold tickets
    items.add(
      'on_hold',
      <TicketStatusFilterButton
        filterStatus={'on_hold'}
        filterIcon={'far fa-pause-circle'}
        isChecked={filters.indexOf(4) >= 0}
        onFilterClick={() => this.attrs.setFilter(4)}
      />
    );

    // Duplicate tickets
    items.add(
      'duplicate',
      <TicketStatusFilterButton
        filterStatus={'duplicate'}
        filterIcon={'far fa-copy'}
        isChecked={filters.indexOf(5) >= 0}
        onFilterClick={() => this.attrs.setFilter(5)}
      />
    );

    return items;
  }
}
